import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTrialSignup } from '../../contexts/TrialSignupContext';
import { checkoutPath } from '../../utils/trialSignup';
import './TrialButton.css';

/**
 * "Start 14-day trial". Signed out, it opens the sign-up popup (step 1 of 2);
 * signed in, or outside the popup's provider, it goes to the pricing page,
 * where a signed-in visitor goes on to Stripe.
 */
export default function TrialButton({ className, children, plan, interval, onClick, ...rest }) {
  const { currentUser } = useAuth();
  const trial = useTrialSignup();

  if (currentUser || !trial) {
    return (
      <Link to={plan ? checkoutPath(plan, interval) : '/pricing'} className={className} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <button
      type="button"
      className={`trial-btn${className ? ` ${className}` : ''}`}
      aria-haspopup="dialog"
      onClick={(e) => {
        onClick?.(e);
        trial.openTrial({ plan, interval });
      }}
      {...rest}
    >
      {children}
    </button>
  );
}
